import { msiRequest } from "../../../index";
import { ResultType } from "../../../types";
import qs from 'qs'
//接口url枚举
enum StatisticalEnumApi{
  CHECK_RULES_PAGE = '/check/rule/query', //盘点规则
  CHECK_RULES_ADD = '/check/rule/add',
  CHECK_RULES_EDIT = '/check/rule/edit',
  CHECK_RULES_DELETE = '/check/rule/delete',
  CHECK_RULES_ORDER = '/check/rule/id'
}
//盘点规则 --- 列表
export function getCheckRulesPage(data: any = {}) {
  return msiRequest.get<ResultType<any>>({
    url: `${StatisticalEnumApi.CHECK_RULES_PAGE}?${qs.stringify(data)}`,
    data
  });
}

//盘点规则 --- 列表
export function getCheckRulesOrder() {
  return msiRequest.get<ResultType<any>>({
    url: StatisticalEnumApi.CHECK_RULES_ORDER
  });
}

//盘点规则 -- 添加
export function addCheckRules(data: any = {}) {
    return msiRequest.post<ResultType<any>>({
      url: `${StatisticalEnumApi.CHECK_RULES_ADD}?${qs.stringify(data)}`,
      data
    });
}

//盘点规则 -- 编辑
export function editCheckRules(data: any = {}) {
  return msiRequest.post<ResultType<any>>({
    url: StatisticalEnumApi.CHECK_RULES_EDIT,
    data
  });
}

//盘点规则 -- 删除
export function deleteCheckRules(data: {orderNo: string}) {
  return msiRequest.post<ResultType<any>>({
    url: StatisticalEnumApi.CHECK_RULES_DELETE,
    data
  });
}